module.exports = __webpack_public_path__ + "static/img/06_click.64621627.png";